import { Box, ColumnLayout, Container, Spinner } from '@cloudscape-design/components';
import React, { useEffect, useState } from 'react';
import { Amplify } from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import config from "../../../../amplifyconfiguration.json";
import { listVehicles } from '../../../../graphql/queries';
import { VehicleMasterTable } from './data list vehicle/data';
import CategoryVehicle from './vehicle-category-chart';
import TypeVehicle from './vehicle-type-chart';
import LocationVehicle from './vehicle-location-chart';
import StatusVehicle from './vehicle-status-chart';

Amplify.configure(config);

const Summary = () => {
  const [vehicleList, setVehicleList] = useState<VehicleMasterTable[]>([]);
  const [totalVehicles, setTotalVehicles] = useState<number>(0);
  const [isLoading, setIsLoading] = React.useState(true);

  const fetchOverview = async (limit = 100) => {
    try {
      const client = generateClient();
      let nextToken: string | null = null;
      let allVehicles: VehicleMasterTable[] = [];

      do {
        const variables = { limit, nextToken };
        const response: any = await client.graphql({
          query: listVehicles,
          authMode : 'userPool',
          variables,
        });

        const vehicles = response.data.listVehicles.items;
        nextToken = response.data.listVehicles.nextToken ?? null;

        const newVehicles: VehicleMasterTable[] = vehicles.map((vehicle: any) => ({
          id: vehicle.id,
          VehicleCode: vehicle.vehiclecode ?? "",
          TypeVehicle: vehicle.typevehicle ?? "",
          Category : vehicle.category ?? "",
          Location: vehicle.location ?? "",
          Status: Boolean(vehicle.status),
          Timestamps: vehicle.updatedAt ?? "",
        }));

        allVehicles = [...allVehicles, ...newVehicles];
      } while (nextToken);

      setVehicleList(allVehicles);
      setTotalVehicles(allVehicles.length);
      setIsLoading(false);
      //console.log(allVehicles);
    } catch (err) {
      console.log("error fetching vehicles: ", err);
    }
  };

  useEffect(() => {
    fetchOverview();
  }, []);

  if(isLoading){
    return (
      <Container fitHeight={true}>
      <ColumnLayout columns={1} minColumnWidth={100}>
      <div style={{ textAlign: "center", marginTop: "60px", marginBottom :"60px" }}>
        <Spinner size="large" /> 
        <Box variant="p">Loading vehicle summary data...</Box>
      </div>
      </ColumnLayout>
    </Container>
    )
  }

  return (
    <Container fitHeight={true}>
      <ColumnLayout columns={4} minColumnWidth={100}>
        <div>
          <CategoryVehicle vehicles={vehicleList} />
        </div>
        <div>
          <TypeVehicle vehicles={vehicleList}  />
        </div>
        <div>
          <LocationVehicle vehicles={vehicleList}  />
        </div>
        <div>
          <StatusVehicle  vehicles={vehicleList}/>
        </div>
      </ColumnLayout>
    </Container>
  );
};

export default Summary;
